import { render, staticRenderFns } from "./authList.vue?vue&type=template&id=47aaad2a&scoped=true"
import script from "./authList.vue?vue&type=script&lang=js"
export * from "./authList.vue?vue&type=script&lang=js"
import style0 from "./authList.vue?vue&type=style&index=0&id=47aaad2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aaad2a",
  null
  
)

export default component.exports